import React, { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import ProductsFormContainer from './ProductsFormContainer';
import { history, route, ROUTE_PRODUCTS } from '../../../../../core/routing/routing';
import { useSelector } from 'react-redux';

const ProductsFormScene = () => {
    const { id } = useParams();
    const workspaceId = useSelector(state => state.app.workspace)

    const handleSuccess = useCallback(() => {
        history.push(route(ROUTE_PRODUCTS, { workspaceId }));
    }, []);

    return (
        <div>
            <ProductsFormContainer id={id} onSuccess={handleSuccess} />
        </div>
    );
};

export default ProductsFormScene;
